export default {"link":"jNwv4","iconContainer":"gIBBe","linkIcon":"TwAIX","linkText":"u4akj","link0":"_5IZSm","link1":"_6Jxad","link3":"_6fi7D"};